import { TableCellType } from "../types";


const tableCellList: TableCellType[] = [
  {
    name: "Name",
    sortField: "name",
  },
  {
    name: "Height",
    sortField: "height",
  },
  {
    name: "Mass",
    sortField: "mass",
  },
  {
    name: "Hair Color",
    sortField: "hair_color",
  },
  {
    name: "Skin Color",
    sortField: "skin_color",
  },
  {
    name: "Eye Color",
    sortField: "eye_color",
  },
  {
    name: "Date of Birth",
    sortField: "birth_year",
  },
  {
    name: "Gender",
    sortField: "gender",
  },
  {
    name: "Home world",
    sortField: "homeworld",
  },
];

export { tableCellList };
